<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberVoucher')" class="btn-grey"><i
                class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Member</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" @searchchange="searchMemberWithoutBranch" @input="onChangeMember"
                      :options="optionsMember" class="border-bottom" name="member_id" v-validate="'required'"
                      v-model="addData.member_id"></model-select>
                  </div>
                  <span class="error">{{ errors.first('ptSession.member_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Vouchers</label>
                </b-col>
                <b-col sm="10">
                  <model-select autocomplete="false" :options="itemVouchers" @input="onVoucherChange"
                    class="border-bottom" name="vouchers" v-validate="'required'"
                    v-model="addData.voucher_id"></model-select>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="addData.voucher_id">
                <b-col sm="2">
                  <label>Voucher Amount</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control border-bottom bg-transparent" v-model="addData.voucher_amount"
                    v-bind="money2" disabled></money>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Transaction</label>
                </b-col>
                <b-col sm="10">
                  <model-select autocomplete="false" :options="itemTransaction" class="border-bottom" name="transaction"
                    v-model="addData.trx_id"></model-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <div class="label-name">Expired Date</div>
                </b-col>
                <b-col sm="10">
                  <flat-pickr :config="config" v-model="addData.expired_at" name="membership_expired_date"
                    class="w-100 border-bottom" @on-close="changeExpiredDate"></flat-pickr>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <div class="label-name">Customer Service</div>
                </b-col>
                <b-col sm="10">
                  <b-form-select v-validate="'required'" name="customer_service" v-model="addData.customer_service_id" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option v-for="item in itemsCs" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('customer_service') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <div class="label-name">Voucher Type</div>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="voucher_type" v-model="addData.voucher_type_id" class="form-control">
                    <option :value="0" selected>Please select</option>
                    <option v-for="item in voucherTypes" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                   <small class="form-text text-muted">*Display on mobile app</small>
                </b-col>
              </b-row>
              <hr>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Mixin from '../../mixins/memberMixin'
import { ModelSelect } from "vue-search-select";
import { MultiSelect } from 'vue-search-select'
import moment from "moment";

export default {
  name: 'addPackage',
  components: {
    ModelSelect,
    MultiSelect
  },
  data: function () {
    return {
      config: {},
      configDate: {
        altInput: true,
        altFormat: "j F Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        enableSeconds: true,
        static: true,
        time_24hr: true
      },
      itemsCs: [],
      money2: {
        decimal: ",",
        thousands: ".",
        prefix: "IDR ",
        suffix: "",
        precision: 2,
        masked: false
      },
      dataMember: [],
      optionsMember: [{ value: null, text: "Please select" }],
      itemVouchers: [],
      itemVouchers2: [],
      voucherTypes: [],
      itemTransaction: [{ value: null, text: "Please select" }],
      addData: {
        member_id: null,
        voucher_id: null,
        voucher_no: null,
        voucher_amount: 0,
        expired_at: null,
        trx_id: null,
        customer_service_id: null,
        voucher_type_id: 0
      }
    }
  },
  mixins: [Mixin],
  methods: {
    onVoucherChange(event) {
      const find = this.itemVouchers2.find((m) => m.id == event);
      console.log(find)
      if (find) {
        this.addData.voucher_amount = find.voucher_amount
      } else {
        this.addData.voucher_amount = 0
      }
    },
    changeExpiredDate(ev) {
      const selected = moment(ev[0]).format("YYYY-MM-DD")
      console.log(selected)
    },
    validateRegister() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addData.voucher_no = this.generateString(8).toUpperCase()

          axios.post('crm/v1/member_voucher', this.addData).then(response => {
            console.log('test', response)
            this.$router.push('/memberVoucher')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    generateString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return result;
    },
    openPage(event) {
      this.$router.push(event)
    },
    onChangeMember(event) {
      console.log(event)
      this.loadTransaction()
    },
    fetchData() {
      axios.get("crm/v1/voucher").then(response => {
        this.itemVouchers2 = response.data.data.rows
        this.itemVouchers = [];
        this.itemVouchers.push({ value: null, text: "Please select" })
        for (let i = 0; i < response.data.data.rows.length; i++) {
          const el = response.data.data.rows[i];
          this.itemVouchers.push({ value: `${el.id}`, text: `${el.name}` })
        }
      }).catch(error => {
        console.log("error", error);
      });

      axios.get('crm/v1/customer_service?status=active&sorting=name&sorting_type=asc').then(response => {
        this.itemsCs = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/member_voucher/voucher_type').then(response => {
        this.voucherTypes = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    loadTransaction() {
      axios.get("crm/v1/voucher/transaction/voucher_transaction?member_id=" + this.addData.member_id).then(response => {
        this.itemTransaction = [];
        this.itemTransaction.push({ value: null, text: "Please select" })
        for (let i = 0; i < response.data.data.rows.length; i++) {
          const el = response.data.data.rows[i];
          this.itemTransaction.push({ value: `${el.id}`, text: `${el.name}` })
        }
      }).catch(error => {
        console.log("error", error);
      });
    }
  },
  created() {
    this.getMemberWithoutBranch()
    this.addData.expired_at = moment().add('day', 7).format("YYYY-MM-DD")
    this.fetchData();
  }
}
</script>

<style></style>
